export default "__VITE_ASSET__mzYP0BDf__"